export const isValidEmail = (email?: string) =>
  !!email?.trim()?.length && email?.includes("@") && email?.includes(".");
